module.exports = __webpack_public_path__ + "img/123.c687a7c7.png";